var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0962 14.3285H8.18956C7.60091 14.3285 7.30659 14.3285 7.17031 14.4449C7.05206 14.5459 6.9893 14.6974 7.0015 14.8525C7.01556 15.0312 7.22368 15.2393 7.63991 15.6555L11.5932 19.6088C11.7856 19.8012 11.8818 19.8974 11.9927 19.9335C12.0903 19.9651 12.1954 19.9651 12.2929 19.9335C12.4039 19.8974 12.5001 19.8012 12.6925 19.6088L16.6458 15.6555C17.062 15.2393 17.2701 15.0312 17.2842 14.8525C17.2964 14.6974 17.2336 14.5459 17.1154 14.4449C16.9791 14.3285 16.6848 14.3285 16.0962 14.3285Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18956 9.67148H16.0962C16.6848 9.67148 16.9791 9.67149 17.1154 9.55508C17.2337 9.45408 17.2964 9.30258 17.2842 9.14754C17.2701 8.96886 17.062 8.76075 16.6458 8.34451L12.6925 4.39122C12.5001 4.19882 12.4039 4.10263 12.2929 4.06659C12.1954 4.03488 12.0903 4.03488 11.9927 4.06659C11.8818 4.10263 11.7856 4.19882 11.5932 4.39122L7.63991 8.34451C7.22368 8.76074 7.01556 8.96886 7.0015 9.14754C6.9893 9.30258 7.05206 9.45408 7.17031 9.55508C7.30659 9.67149 7.60091 9.67148 8.18956 9.67148Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/Sort.eeda361277648bf0bca6907152a5d0a0.svg";
export { ForwardRef as ReactComponent };